<script>
    export let text = "";
    import { onDestroy, onMount } from "svelte";

    const initialWaveStrength = 0.7;

    const getWave = (initialStrength) => {
        let strength = initialStrength;
        let propagation = 0;
        let deltaSum = 0;
        return {
            getRawStrength: () => strength,
            getStrength: () => strength * Math.sin(propagation / 2),
            update: (delta) => {
                deltaSum += delta;
                propagation +=  50 * delta;
                strength = Math.max(0, initialStrength - (Math.pow(deltaSum, 2) * 4));
            },
        };
    };

    const wavePerLetter = text.split("").map((_letter) => []);
    let letterWaveStrength = text.split("").map((_letter) => 0);

    const updateLetterWaveStrength = (delta) => {
        letterWaveStrength = wavePerLetter.map((waves, i) => {
            let strength = 0;
            let strengthMax = initialWaveStrength * 2;
            waves.forEach((wave) => {
                wave.update(delta);
                strength +=
                    (wave.getStrength() * (strength - strengthMax)) /
                    strengthMax;
            });
            return strength;
        });
    };

    const loopUpdate = (delta) => {
        updateLetterWaveStrength(delta);
    };

    const removeDoneWaves = () => {
        wavePerLetter.forEach((waves, i) => {
            wavePerLetter[i] = wavePerLetter[i].filter(
                (wave) => wave.getRawStrength() > 0.01
            );
        });
    };

    const carryOver = 0.6;
    const propagateWave = (initialIndex, currentIndex, nextIndex) => {
        let i = currentIndex;
        if (i < 0 || i >= text.length) return;
        const currentcarryOver = Math.pow(
            carryOver,
            Math.abs(initialIndex - i)
        );
        if (currentcarryOver < 0.1) return;
        setTimeout(() => {
            wavePerLetter[i].push(getWave(initialWaveStrength * currentcarryOver));
            propagateWave(initialIndex, nextIndex(i), nextIndex);
        }, 100);
    };

    const addWave = (index) => {
        wavePerLetter[index].push(getWave(initialWaveStrength));
        removeDoneWaves();

        propagateWave(index, index + 1, (x) => x + 1);
        propagateWave(index, index - 1, (x) => x - 1);
    };

    let animFrame;
    let delta = 0;
    let time = 0;
    const animFrameloop = (animTime) => {
        delta = (animTime - time) / 1000;
        time = animTime;
        animFrame = requestAnimationFrame(animFrameloop);
        loopUpdate(delta || 1);
    };

    onMount(() => {
        animFrameloop(0);
    });

    onDestroy(() => {
        if (animFrame) cancelAnimationFrame(animFrame);
    });
</script>

<div class="word">
    {#each text as letter, i}
        <div
            on:click={() => addWave(i)}
            on:mouseenter={() => addWave(i)}
            class="letter-wrapper"
        >
            <div
                class="letter"
                style="transform: scale({1 + 0.25 * letterWaveStrength[i]}, {1 +
                    0.5 * -letterWaveStrength[i]})"
            >
                {letter}
            </div>
        </div>
    {/each}
</div>

<style>
    .word {
        display: flex;
        justify-content: center;
        align-items: center;

        font-weight: bold;
    }

    .letter-wrapper {
        padding: 0px 2px;
    }

    .letter {
        font-size: 64px;
        user-select: none;

        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-user-select: none;
    }
    @media only screen and (min-width: 768px) {
        .letter {
            font-size: 120px;
        }
    }
</style>
